<template>
  <div class="actions-checkbox">
    <div class="row">
      <div class="col-12 pl-0 d-flex align-items-center apply-block">
        <div class="mr-1">
          <span>Apply to:</span>
        </div>
        
        <SelectTemplateDropdown
          v-if="target.canvas"
          :current-instance-id="target.canvas.instance_id"
          :local-storage-key="LOCAL_STORAGE_KEY_SELECTED_TEMPLATES_FOR_TEXT"
        />

        <SelectPropertiesDropdown
          :is-color-selector="!!options.colorSelector"
          :is-font-selector="!!options.fontSelector"
          :is-alignment-selector="!!options.alignmentSelector"
          :is-banner-builder="isBannerBuilder"
          @change="onChange"
        />

        <ApplyInfoButton
          actions-text="properties"
          class="ml-1"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SelectTemplateDropdown from './SelectTemplateDropdown.vue';
import SelectPropertiesDropdown from './SelectPropertiesDropdown.vue';
import { editorControlEventBroker, EVENTS } from '@frontend/group/modules/editor-control-popup/event-broker';
import {
  LOCAL_STORAGE_KEY_SELECTED_TEMPLATES_FOR_TEXT,
} from '@frontend/group/modules/editor-control-popup/selected-template-for-apply-to-all'
import ApplyInfoButton from '@frontend/components/modules/layouts-page/EditorControl/components/ApplyInfoButton.vue'

export default {
  name: 'ApplyToAllTextDropdown',
  
  components: { ApplyInfoButton, SelectTemplateDropdown, SelectPropertiesDropdown },

  props: {
    target: {
      type: Object,
      default: () => {
      },
    },
    options: {
      type: Object,
      default: () => {
      },
    },
    isBannerBuilder: {
      type: Boolean,
      default: false
    },
  },
  
  data() {
    return {
      selectedPropertyKeys: [],
      LOCAL_STORAGE_KEY_SELECTED_TEMPLATES_FOR_TEXT,
    };
  },
  
  methods: {
    onChange(action, value) {
      editorControlEventBroker.fire(EVENTS.TEXT_CHANGED, {
        action,
        value,
        keys: [...this.selectedPropertyKeys],
      });
    }
  }
};
</script>

<style scoped>
</style>
